import React, { useEffect,useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Button,
  Modal,
  TextField,
  Stack,
  Checkbox,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Pagination,
  CircularProgress,
  Snackbar,
  Alert,
} from '@mui/material';
import config from '../config';

const server_URL = config.SERVER_URL;

// Utility function to format date as DD-MM-YYYY, HH:MM:SS am/pm
const formatDateTime = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const displayHours = hours % 12 || 12;
  
  return `${day}-${month}-${year}, ${displayHours}:${minutes}:${seconds} ${ampm}`;
};

// Dummy data to simulate email lists imported from Excel


const List = () => {
  const [openModal, setOpenModal] = useState(false);
  const [listName, setListName] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [emailList, setEmailList] = useState([]);
  const [viewModal, setViewModal] = useState(false);
  const [selectedListDetails, setSelectedListDetails] = useState([]);
  const [selectedListCustomFields, setSelectedListCustomFields] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isLoadingDetails, setIsLoadingDetails] = useState(false);
  const [selectedListId, setSelectedListId] = useState(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const itemsPerPage = 100; // Show 100 records per page
  const [isTestList, setIsTestList] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadStatus, setUploadStatus] = useState('');
  const [deletingId, setDeletingId] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState('');
  const [customFieldsList, setCustomFieldsList] = useState([]);
  const [selectedCustomFields, setSelectedCustomFields] = useState('');
  const [userRole, setUserRole] = useState(null);
  const [loggedUserId, setLoggedUserId] = useState(null);
  const [customerFilter, setCustomerFilter] = useState('');
  const [toastState, setToastState] = useState({ open: false, message: '', severity: 'info' });

  const showToast = (message, severity = 'info') => {
    setToastState({ open: true, message, severity });
  };

  const handleFileUpload = (event) => {
    setSelectedFile(event.target.files[0]);
  };
  
  useEffect(() => {
    fetchEmailLists();
    // Get logged user info
    const userData = JSON.parse(localStorage.getItem('user') || '{}');
    setUserRole(userData.role_id || null);
    setLoggedUserId(userData.id || null);
    // If role is 2, set selected customer to logged user
    if (userData.role_id === 2) {
      setSelectedCustomer(userData.id);
    }
  }, []);

  useEffect(() => {
    if (userRole !== null && loggedUserId !== null) {
      fetchCustomers();
    }
  }, [userRole, loggedUserId]);

  useEffect(() => {
    if (selectedCustomer && selectedCustomer !== '') {
      fetchCustomFieldsForCustomer(selectedCustomer);
    } else {
      setCustomFieldsList([]);
      setSelectedCustomFields('');
    }
  }, [selectedCustomer]);

  const fetchCustomers = async () => {
    try {
      const response = await fetch(server_URL + '/api/customers', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          method: 'list',
          user_id: loggedUserId,
          role_id: userRole
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to fetch customers');
      }

      const data = await response.json();
      if (data.status === '1' && data.data) {
        setCustomers(data.data);
        
        // Auto-select if only one customer
        if (data.data.length === 1) {
          setSelectedCustomer(data.data[0].id);
        }
      }
    } catch (error) {
      console.error('Error fetching customers:', error);
    }
  };

  const fetchCustomFieldsForCustomer = async (customerId) => {
    try {
      const userData = JSON.parse(localStorage.getItem('user') || '{}');
      const response = await fetch(server_URL + '/api/custom_fields', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          method: 'list',
          user_id: userData.id,
          user_role: userData.role_id,
          client_id: customerId,
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to fetch custom fields');
      }

      const data = await response.json();
      if (data.status === '1' && data.data) {
        setCustomFieldsList(data.data || []);
      } else {
        setCustomFieldsList([]);
      }
    } catch (error) {
      console.error('Error fetching custom fields:', error);
      setCustomFieldsList([]);
    }
  };
  const fetchEmailLists = async (filterCustomerId = null) => {
    setIsLoading(true);
    try {
      const userData = JSON.parse(localStorage.getItem('user') || '{}');
      const requestBody = {
        method: 'list',
        user_id: userData.id || null,
        role_id: userData.role_id || null
      };
      
      // Add customer filter if provided
      if (filterCustomerId !== null && filterCustomerId !== '') {
        const customerIdValue = String(filterCustomerId) === '0' ? 0 : parseInt(filterCustomerId, 10);
        requestBody.customer_id = customerIdValue;
        console.log('Filtering by customer_id:', customerIdValue);
      }
      
      console.log('Request body:', requestBody);
      
      const response = await fetch(server_URL+ '/api/emaillist', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error('Failed to fetch email lists');
      }

      const data = await response.json();
      console.log('Received email list data:', data); // Debug log
      
      // Ensure we're setting an array
      const listData = Array.isArray(data) ? data : data.data || [];
      // Sort newest first: prefer created_at, fallback to id
      const sorted = [...listData].sort((a, b) => {
        if (a.created_at && b.created_at) {
          return new Date(b.created_at) - new Date(a.created_at);
        }
        if (a.id && b.id) {
          return b.id - a.id;
        }
        return 0;
      });
      setEmailList(sorted);
      
      if (listData.length === 0) {
        console.log('No email lists found matching the filter criteria');
      } else {
        console.log(`Found ${listData.length} email list(s)`);
      }
    } catch (error) {
      console.error('Error fetching email lists:', error);
      setEmailList([]); // Set empty array on error
    } finally {
      setIsLoading(false);
    }
  };
  
  const handleFilter = () => {
    fetchEmailLists(customerFilter);
  };
  
  const handleClearFilter = () => {
    setCustomerFilter('');
    fetchEmailLists();
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate customer selection (allow 0 for role 1 users)
    if (selectedCustomer === '' || selectedCustomer === null || selectedCustomer === undefined) {
      alert('Please select a customer');
      return;
    }
    
    setIsUploading(true);
    setUploadProgress(0);
    setUploadStatus('Uploading file...');
    
    const userData = JSON.parse(localStorage.getItem('user') || '{}');
    const formData = new FormData();
    formData.append('method', 'add');
    formData.append('listName', listName);
    formData.append('file', selectedFile);
    formData.append('isTestList', isTestList.toString());
    formData.append('user_id', userData.id);
    formData.append('customer_id', selectedCustomer); // Add customer_id
    formData.append('is_subuser', (userData.is_subuser || false).toString());
    formData.append('subuser_id', userData.subuser_id || '');
    if (selectedCustomFields && selectedCustomFields !== '') {
      formData.append('custom_fields_id', selectedCustomFields); // Add custom_fields_id (optional)
    }

    try {
      // Use XMLHttpRequest for progress tracking on large files
      const xhr = new XMLHttpRequest();
      
      // Track upload progress
      xhr.upload.addEventListener('progress', (e) => {
        if (e.lengthComputable) {
          const percentComplete = Math.round((e.loaded / e.total) * 50); // First 50% is upload
          setUploadProgress(percentComplete);
          setUploadStatus(`Uploading file... ${percentComplete}%`);
        }
      });
      
      // Track processing progress (after upload)
      xhr.addEventListener('load', () => {
        setUploadProgress(75);
        setUploadStatus('Processing Excel file... This may take a few minutes for large files.');
      });
      
      return new Promise((resolve, reject) => {
        xhr.onload = () => {
          if (xhr.status === 200) {
            try {
              const data = JSON.parse(xhr.responseText);
              setUploadProgress(100);
              setUploadStatus('Upload complete!');
              
              if (data.status === 1 || data.status === '1') {
                // Check if processing is happening in background
                if (data.data && data.data.processing) {
                  // Large file - processing in background
                  const message = data.message || 'Large file detected. Processing started in background. The list will be updated when processing completes.';
                  showToast(message, 'info');
                  setOpenModal(false);
                  fetchEmailLists();
                  // Reset form
                  setListName('');
                  setSelectedFile(null);
                  setIsTestList(false);
                  setSelectedCustomer(userRole === 2 ? loggedUserId : '');
                  setSelectedCustomFields('');
                  setUploadProgress(0);
                  setUploadStatus('');
                  setIsUploading(false);
                  resolve(data);
                } else {
                  // Small file - processed immediately
                  showToast('Email list added successfully', 'success');
                  setTimeout(() => {
                    setOpenModal(false);
                    fetchEmailLists();
                    // Reset form
                    setListName('');
                    setSelectedFile(null);
                    setIsTestList(false);
                    setSelectedCustomer(userRole === 2 ? loggedUserId : '');
                    setSelectedCustomFields('');
                    setUploadProgress(0);
                    setUploadStatus('');
                    setIsUploading(false);
                  }, 1000);
                  resolve(data);
                }
              } else {
                const errorMsg = data.message || data.error || 'Failed to upload file';
                showToast(errorMsg, 'error');
                setUploadProgress(0);
                setUploadStatus('');
                setIsUploading(false);
                reject(new Error(errorMsg));
              }
            } catch (parseError) {
              console.error('Error parsing response:', parseError);
              console.error('Response text:', xhr.responseText);
              showToast('An error occurred while processing the response', 'error');
              setUploadProgress(0);
              setUploadStatus('');
              setIsUploading(false);
              reject(parseError);
            }
          } else {
            const errorMsg = `Upload failed with status ${xhr.status}`;
            showToast(errorMsg, 'error');
            setUploadProgress(0);
            setUploadStatus('');
            setIsUploading(false);
            reject(new Error(`HTTP ${xhr.status}`));
          }
        };
        
        xhr.onerror = () => {
          console.error('Error uploading file:', xhr.statusText);
          showToast('An error occurred during file upload', 'error');
          setUploadProgress(0);
          setUploadStatus('');
          setIsUploading(false);
          reject(new Error('Network error'));
        };
        
        xhr.open('POST', `${server_URL}/api/emaillist`);
        xhr.send(formData);
      });
    } catch (error) {
      console.error('Error uploading file:', error);
      alert('An error occurred during file upload');
      setUploadProgress(0);
      setUploadStatus('');
      setIsUploading(false);
    }
  };

  const handleView = async (id, listName, page = 1) => {
    setIsLoadingDetails(true);
    setSelectedListId(id);
    setCurrentPage(page);
    
    try {
      // Find the list to get custom fields info
      const list = emailList.find(l => l.id === id);
      if (list && list.custom_fields) {
        setSelectedListCustomFields(list.custom_fields);
      } else {
        setSelectedListCustomFields([]);
      }

      const response = await fetch(`${server_URL}/api/emaillist`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          'method': 'getemaillist',
          'list_id': id,
          'page': page,
          'per_page': itemsPerPage
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to fetch list details');
      }

      const data = await response.json();
      if (data.status === '1') {
        setSelectedListDetails(data.data || []);
        if (data.pagination) {
          setTotalPages(data.pagination.total_pages);
          setTotalRecords(data.pagination.total_records);
        }
        setViewModal(true);
      } else {
        alert(data.error || 'Failed to fetch list details');
      }
    } catch (error) {
      console.error('Error fetching list details:', error);
      alert('An error occurred while fetching list details');
    } finally {
      setIsLoadingDetails(false);
    }
  };

  const handlePageChange = (event, value) => {
    if (selectedListId) {
      handleView(selectedListId, null, value);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this list?')) {
      return;
    }

    setDeletingId(id);
    try {
      const userData = JSON.parse(localStorage.getItem('user') || '{}');
      const response = await fetch(`${server_URL}/api/emaillist`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          method: 'delete',
          id: id,
          user_id: userData.id,
          is_subuser: userData.is_subuser || false,
          subuser_id: userData.subuser_id || null,
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to delete email list');
      }

      await fetchEmailLists();
    } catch (error) {
      console.error('Error deleting list:', error);
      alert('Failed to delete list');
    } finally {
      setDeletingId(null);
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4">
          Email Lists
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setOpenModal(true)}
        >
          Add List
        </Button>
      </Box>
      
      {/* Customer Filter - Only show for role 1 (admin) */}
      {userRole === 1 && (
        <Box sx={{ 
          display: 'flex', 
          gap: 2, 
          alignItems: 'center', 
          mb: 3,
          p: 2,
          bgcolor: '#f5f5f5',
          borderRadius: 1
        }}>
          <FormControl sx={{ minWidth: 250 }}>
            <InputLabel>Filter by Customer</InputLabel>
            <Select
              value={customerFilter}
              onChange={(e) => setCustomerFilter(e.target.value)}
              label="Filter by Customer"
              size="small"
            >
              <MenuItem value="">All Customers</MenuItem>
              {/* <MenuItem value="0">Common (No Customer)</MenuItem> */}
              {customers.filter(customer => customer.id !== 0).map((customer) => (
                <MenuItem key={customer.id} value={customer.id}>
                  {customer.username} ({customer.email})
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button 
            variant="contained"
            onClick={handleFilter}
            sx={{ height: '40px' }}
          >
            Filter
          </Button>
          {customerFilter !== '' && (
            <Button 
              variant="outlined"
              color="warning"
              onClick={handleClearFilter}
              sx={{ height: '40px' }}
            >
              Clear Filter
            </Button>
          )}
          <Button 
            variant="outlined"
            onClick={() => fetchEmailLists(customerFilter)}
            sx={{ height: '40px' }}
          >
            Refresh
          </Button>
        </Box>
      )}
      
      {isLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
          <Box sx={{ textAlign: 'center' }}>
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <Typography sx={{ mt: 2 }}>Loading email lists...</Typography>
          </Box>
        </Box>
      ) : (
        <Modal
          open={openModal}
          onClose={() => {
            setOpenModal(false);
            // Reset form
            setListName('');
            setSelectedFile(null);
            setIsTestList(false);
            setSelectedCustomer(userRole === 2 ? loggedUserId : '');
            setSelectedCustomFields('');
          }}
          aria-labelledby="upload-modal-title"
        >
          <Box sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}>
            <Typography id="upload-modal-title" variant="h6" component="h2" mb={3}>
              Add New Email List
            </Typography>
            <Stack spacing={3}>
              <TextField
                label="List Name"
                value={listName}
                onChange={(e) => setListName(e.target.value)}
                fullWidth
                required
              />
              <FormControl fullWidth required>
                <InputLabel>Customer</InputLabel>
                <Select
                  value={selectedCustomer}
                  onChange={(e) => {
                    setSelectedCustomer(e.target.value);
                    setSelectedCustomFields(''); // Reset custom fields when customer changes
                  }}
                  label="Customer"
                  disabled={userRole === 2} // Disable for role 2 users (only their own account)
                >
                  {/* {userRole === 1 && (
                    <MenuItem value={0}>
                      Common (No Customer)
                    </MenuItem>
                  )} */}
                  {customers.map((customer) => (
                    <MenuItem key={customer.id} value={customer.id}>
                      {customer.username} ({customer.email})
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {/* {selectedCustomer && selectedCustomer !== '' && selectedCustomer !== 0 && ( */}
                <FormControl fullWidth>
                  <InputLabel>Custom Fields (Optional)</InputLabel>
                  <Select
                    value={selectedCustomFields}
                    onChange={(e) => setSelectedCustomFields(e.target.value)}
                    label="Custom Fields (Optional)"
                  >
                    <MenuItem value="">No Custom Fields</MenuItem>
                    {customFieldsList.map((cf) => (
                      <MenuItem key={cf.id} value={cf.id}>
                        {cf.custom_fields && cf.custom_fields.length > 0
                          ? `${cf.custom_fields.length} field set(s) - ${cf.custom_fields.map(f => f.name).join(', ')}`
                          : `Custom Fields #${cf.id}`
                        }
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              {/* )} */}
              <input
                accept=".xlsx,.xls"
                style={{ display: 'none' }}
                id="file-upload"
                type="file"
                onChange={handleFileUpload}
              />
              <label htmlFor="file-upload">
                <Button variant="outlined" component="span" fullWidth>
                  {selectedFile ? selectedFile.name : 'Choose Excel File'}
                </Button>
              </label>
              {userRole !== 2 && (
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Checkbox
                    checked={isTestList}
                    onChange={(e) => setIsTestList(e.target.checked)}
                    id="test-list-checkbox"
                  />
                  <Typography>Add emails for testing</Typography>
                </Box>
              )}
              {isUploading && (
                <Box sx={{ width: '100%', mb: 2 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography variant="body2" color="text.secondary">
                      {uploadStatus || 'Processing...'}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {uploadProgress}%
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      width: '100%',
                      height: 8,
                      backgroundColor: '#e0e0e0',
                      borderRadius: 4,
                      overflow: 'hidden',
                    }}
                  >
                    <Box
                      sx={{
                        width: `${uploadProgress}%`,
                        height: '100%',
                        backgroundColor: 'primary.main',
                        transition: 'width 0.3s ease',
                      }}
                    />
                  </Box>
                  <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                    {selectedFile && selectedFile.size > 10 * 1024 * 1024 
                      ? 'Large file detected. Processing may take several minutes. Please do not close this window.'
                      : 'Processing your file...'}
                  </Typography>
                </Box>
              )}
              <Button
                variant="contained"
                onClick={handleSubmit}
                disabled={!listName || !selectedFile || (selectedCustomer !== 0 && !selectedCustomer) || isUploading}
                fullWidth
              >
                {isUploading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    {uploadStatus || 'Processing...'}
                  </>
                ) : (
                  'Upload'
                )}
              </Button>
              <Button
                variant="outlined"
                color="primary"
                component="a" 
                href="/assets/EmailCampaign.xlsx"
                download="EmailCampaign.xlsx"
                fullWidth
                sx={{ mt: 2 }}
              >
                Download Sample Excel File
              </Button>
            </Stack>
          </Box>
        </Modal>
      )}

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>List Name</TableCell>
              {userRole === 1 && <TableCell>Customer</TableCell>}
              <TableCell>Custom Fields</TableCell>
              <TableCell>Test List</TableCell>
              <TableCell>Upload Date</TableCell>
              <TableCell>Total Emails</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {emailList.length === 0 ? (
              <TableRow>
                <TableCell colSpan={userRole === 1 ? 7 : 6} align="center" sx={{ py: 5 }}>
                  <Typography variant="h6" color="text.secondary">
                    No email lists found
                  </Typography>
                  {customerFilter !== '' && (
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                      Try clearing the filter or selecting a different customer
                    </Typography>
                  )}
                </TableCell>
              </TableRow>
            ) : (
              emailList.map((list) => (
                <TableRow 
                  key={list.id}
                  hover
                  sx={{ cursor: 'pointer' }}
                >
                  <TableCell>{list.list_name}</TableCell>
                  {userRole === 1 && (
                    <TableCell>
                      {list.customer_username || 'Common (No Customer)'}
                      {list.customer_email && (
                        <Typography variant="caption" display="block" sx={{ color: '#666', fontSize: '0.75rem' }}>
                          {list.customer_email}
                        </Typography>
                      )}
                    </TableCell>
                  )}
                  <TableCell>
                    {list.custom_fields && list.custom_fields.length > 0 ? (
                      <Box>
                        {list.custom_fields.map((cf, idx) => (
                          <Typography key={idx} variant="body2" sx={{ fontSize: '0.75rem' }}>
                            {cf.tag}: {cf.name} ({cf.key})
                          </Typography>
                        ))}
                      </Box>
                    ) : (
                      <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                        None
                      </Typography>
                    )}
                  </TableCell>
                  <TableCell>{list.isTestList ? 'Yes' : 'No'}</TableCell>
                  <TableCell>{formatDateTime(list.upload_date)}</TableCell>
                  <TableCell>{list.total_emails}</TableCell>
                  <TableCell>
                    <Button
                      variant="outlined"
                      color="primary"
                      size="small"
                      sx={{ mr: 1 }}
                      onClick={() => handleView(list.id, list.list_name)}
                    >
                      View
                    </Button>
                    <Button
                      variant="outlined"
                      color="error"
                      size="small"
                      onClick={() => handleDelete(list.id)}
                      disabled={deletingId === list.id}
                    >
                      {deletingId === list.id ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Deleting...
                        </>
                      ) : (
                        'Delete'
                      )}
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Modal
        open={viewModal}
        onClose={() => {
          setViewModal(false);
          setSelectedListCustomFields([]);
          setSelectedListDetails([]);
          setCurrentPage(1);
          setTotalPages(1);
          setTotalRecords(0);
          setSelectedListId(null);
        }}
        aria-labelledby="view-modal-title"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          maxWidth: '1200px',
          maxHeight: '90vh',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
            <Typography id="view-modal-title" variant="h6" component="h2">
              Email List Details
            </Typography>
            {totalRecords > 0 && (
              <Typography variant="body2" color="text.secondary">
                Total Records: {totalRecords} | Page {currentPage} of {totalPages}
              </Typography>
            )}
          </Box>
          
          {isLoadingDetails ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
              <Box sx={{ textAlign: 'center' }}>
                <CircularProgress size={50} />
                <Typography variant="body1" sx={{ mt: 2 }}>
                  Loading email list details...
                </Typography>
              </Box>
            </Box>
          ) : (
            <>
              <TableContainer component={Paper} sx={{ flex: 1, overflow: 'auto', mb: 2 }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell><strong>S.No</strong></TableCell>
                      <TableCell><strong>Email</strong></TableCell>
                      <TableCell><strong>First Name</strong></TableCell>
                      <TableCell><strong>Last Name</strong></TableCell>
                      {selectedListCustomFields.map((cf, idx) => (
                        <TableCell key={idx}><strong>{cf.name}</strong></TableCell>
                      ))}
                      <TableCell><strong>Status</strong></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {selectedListDetails.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={4 + selectedListCustomFields.length + 1} align="center" sx={{ py: 5 }}>
                          <Typography variant="body1" color="text.secondary">
                            No emails found in this list
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ) : (
                      selectedListDetails.map((item, index) => {
                        // Calculate actual serial number based on current page
                        const serialNumber = (currentPage - 1) * itemsPerPage + index + 1;
                        
                        return (
                          <TableRow key={item.id || index} hover>
                            <TableCell>{serialNumber}</TableCell>
                            <TableCell>
                              {item.email}
                            </TableCell>
                            <TableCell>{item.first_name || '-'}</TableCell>
                            <TableCell>{item.last_name || '-'}</TableCell>
                            {selectedListCustomFields.map((cf, idx) => {
                              // Get the custom field value based on the tag (cust1, cust2, etc.)
                              const custValue = item[cf.tag] || '';
                              return (
                                <TableCell key={idx}>{custValue || '-'}</TableCell>
                              );
                            })}
                            <TableCell>
                              <Typography 
                                variant="body2" 
                                sx={{ 
                                  color: item.unsubscribed ? 'error.main' : 'success.main',
                                  fontWeight: item.unsubscribed ? 'bold' : 'normal'
                                }}
                              >
                                {item.unsubscribed ? 'Unsubscribed' : 'Active'}
                              </Typography>
                            </TableCell>
                          </TableRow>
                        );
                      })
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              
              {totalPages > 1 && (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                  <Pagination
                    count={totalPages}
                    page={currentPage}
                    onChange={handlePageChange}
                    color="primary"
                    size="large"
                    showFirstButton
                    showLastButton
                  />
                </Box>
              )}
            </>
          )}
        </Box>
      </Modal>

      {/* Toast Notification */}
      <Snackbar
        open={toastState.open}
        autoHideDuration={6000}
        onClose={() => setToastState({ ...toastState, open: false })}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={() => setToastState({ ...toastState, open: false })}
          severity={toastState.severity}
          sx={{ width: '100%' }}
        >
          {toastState.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default List;
